import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router';
import { CircularProgressbarWithChildren, buildStyles } from 'react-circular-progressbar';
import 'react-circular-progressbar/dist/styles.css';

const CircularProgressBar = (props) => {
  const [progress, setProgress] = useState(0);
  const [skill_Id, setSkillId] = useState(props.skill_Id);
  const [nextLearningBite, setNextLearningBite] = useState(props.nextLearningBite);
  const history = useHistory();
  let interval; // Define the interval variable here
  let timeout;
  useEffect(() => {
    interval = setInterval(() => {
      setProgress((prevProgress) => prevProgress + 1);
    }, 1000);

    // Set the timeout here and store it in the timeout variable
    timeout = setTimeout(() => {
      clearInterval(interval);
      redirect();
    }, 60000);

    return () => {
      clearInterval(interval);
      clearTimeout(timeout); // Clear the timeout when unmounting
    };
  }, []);

  const redirect = () => {
    console.log("inside")
    window.location.href = `/lessons/${skill_Id}/${nextLearningBite}`;
  };

  const onClickCancel = () => {
    clearInterval(interval);
    clearTimeout(timeout); // Clear the timeout when "Cancel" is clicked
    history.push(`/skills/${skill_Id}`);
  }

  return (
    <div>
      <div className="circulerPrgressbar" onClick={redirect}>
        <CircularProgressbarWithChildren
          value={progress}
          maxValue={60}
          styles={buildStyles({
            pathTransitionDuration: 0.15,
            pathColor: "#000000",
            trailColor: "#B9B8B7",
          })}
        >
          <img
            src={require("./play-icon-black.png")}
            className="img"
          />
        </CircularProgressbarWithChildren>
      </div>
      <div style={{ textAlign: "center" }}>
        <div className="cancelBtnBlock" onClick={onClickCancel}>
          <div>
            <button>Cancel</button>
          </div>
        </div>
      </div>
    </div>

  );
};

export default CircularProgressBar;
